<template>
  <div class="similar-fac">
    <h2 class="sub-heading">
      {{ title }}
    </h2>
    <ul>
      <li v-for="(facilityEventType, index) in facilityEventTypes" :key="index">
        <nuxt-link :to="facilityEventType.url">{{
          facilityEventType.title
        }}</nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { createUrl } from '@/utils/create-url'
import { methods } from '@/utils/methods'
export default {
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      return (
        this.detail.prefecture +
        'から同じ収容人数の格安セミナー会場（貸し会議室・ホール・レンタルスペース）を探す'
      )
    },
    facilityEventTypes() {
      // イベント規模・種類の配列を整形
      const formatedFacilityEventTypesList = methods.formatFacilityEventTypesList(
        this.detail.event_type
      )

      // 単一配列に変換
      const facilityEventTypes = []
      formatedFacilityEventTypesList.forEach((formatedFacilityEventType) => {
        facilityEventTypes.push(...formatedFacilityEventType)
      })

      // url を追加
      // タイトルの先頭に都道府県を付与
      return facilityEventTypes.map((facilityEventType) => {
        const query = {
          prefecture: this.detail.prefecture,
          eventType: [facilityEventType.code]
        }
        facilityEventType.url = createUrl.createSearchUrl(query)
        facilityEventType.title =
          this.detail.prefecture + 'の' + facilityEventType.title
        return facilityEventType
      })
    }
  }
}
</script>
